<template>
<breadCrumbs title="Wishlist" main="Ecommerce" title1="Wishlist" />

<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header pb-0">
                    <h3>Wishlist</h3>
                </div>
                <div class="card-body whishlist-main">
                    <div class="row" >
                        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6 box-col-3" v-for="(item,index) in menu" :key="index">
                            <div class="product-details-box">
                                <div class="d-flex"><router-link :to="'/ecommerce/product/page/' + item.id"><img class="align-self-center img-fluid" :src="getImgUrl(item.img)" alt=""></router-link>
                                    <div class="flex-grow-1">
                                        <div class="product-name"><router-link :to="'/ecommerce/product/page/' + item.id">
                                                <h6>{{item.product}}</h6>
                                        </router-link></div>
                                        <ul class="rating">
                                            <li><i class="fa fa-star"></i></li>
                                            <li><i class="fa fa-star"></i></li>
                                            <li><i class="fa fa-star"></i></li>
                                            <li><i class="fa fa-star"></i></li>
                                            <li><i class="fa fa-star-o"></i></li>
                                        </ul>
                                        <div class="price">Price<span>: {{item.price}}</span></div>
                                        <div class="avaiabilty">
                                            <div class="text-success">{{item.stock}}</div>
                                        </div><router-link class="btn btn-primary btn-xs" to="/ecommerce/cart">Move to Cart</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
import order from '../../../data/wishlist.json'

export default {
    name: 'wishlistView',
    data(){
            return{
                menu: order.data
            }
        },
        methods: {
        getImgUrl(path) {
            return require("../../../assets/images/" + path);
        },
    }

}
</script>
